import { render, staticRenderFns } from "./DetailBuyer.vue?vue&type=template&id=3da57a8a&"
import script from "./DetailBuyer.vue?vue&type=script&lang=js&"
export * from "./DetailBuyer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports